import { render, staticRenderFns } from "./ItemAccessCar.vue?vue&type=template&id=2c3bbcef&"
import script from "./ItemAccessCar.vue?vue&type=script&lang=ts&"
export * from "./ItemAccessCar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3bbcef')) {
      api.createRecord('2c3bbcef', component.options)
    } else {
      api.reload('2c3bbcef', component.options)
    }
    module.hot.accept("./ItemAccessCar.vue?vue&type=template&id=2c3bbcef&", function () {
      api.rerender('2c3bbcef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/ItemAccessCar.vue"
export default component.exports